<template>
  <div ref="topStorySlider" class="swiper__carousel">
    <div class="swiper__row">
      <div v-for="(article,index) in topStories" :key="index" class="swiper__col">
        <GridSlider
          :article="article"
        />
      </div>
    </div> 
    <div class="ts__nav ts__nav-prev">
      <svg class="ts__nav-prev-icon">
        <use xlink:href="#icon-prev"></use>
      </svg>
    </div>
    <div class="ts__nav ts__nav-next">
      <svg class="ts__nav-next-icon">
        <use xlink:href="#icon-next"></use>
      </svg>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted } from 'vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';
  import GridSlider from './components/grid-slider.vue';
  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    data: {
      type: Array,
      required: true,
    },
  });

  const { data } = toRefs(props);

  var topStorySlider = ref(null);

  onMounted(() => {
    new Swiper(topStorySlider.value, topStorySwiper.value);
  });

  const topStories = computed(() => {
    return data.value.articles.slice(0, data.value.articleLimit);
  });

  const topStorySwiper = computed(() => {
    return {
      slidesPerView: 1.28,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      wrapperClass: 'swiper__row',
      slideClass: 'swiper__col',
      navigation: {
        nextEl: '.ts__nav-next',
        prevEl: '.ts__nav-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.25,
        },
      },
      a11y: {
        enabled: true,
        slideLabelMessage: null,
      },
    };
  });
</script>
